import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const getInvoices = async () => {
  let res = await axios.get(process.env.REACT_APP_BACKEND_URL + 'api/invoices/?populate=*', getAuthorizationHeader())
  return res.data.data;
}